var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "MotivodeBaja" },
    [
      _c(
        "FormFieldsContainer",
        [
          _c(
            "v-flex",
            { attrs: { sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                staticStyle: { "margin-right": "5px" },
                attrs: { label: "Buscar...", "append-icon": "search" },
                on: { input: _vm.searchData },
                model: {
                  value: _vm.filtrobusquedagrilla,
                  callback: function($$v) {
                    _vm.filtrobusquedagrilla = $$v
                  },
                  expression: "filtrobusquedagrilla"
                }
              })
            ],
            1
          ),
          _c("v-flex", { attrs: { xs12: "", sm6: "", md4: "" } }),
          _c(
            "v-flex",
            {
              staticStyle: { "padding-right": "0px" },
              attrs: { xs12: "", sm6: "", md4: "" }
            },
            [
              _c(
                "div",
                {
                  staticStyle: { "padding-top": "6px", "padding-right": "0px" },
                  attrs: { align: "right" }
                },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { flat: "", small: "", color: "primary" },
                      on: { click: _vm.exportarExcel }
                    },
                    [
                      _c("v-icon", { staticClass: "importExportBtnIcon" }, [
                        _vm._v("cloud_download")
                      ]),
                      _vm._v("  \n          "),
                      _c("span", { staticClass: "importExportBtnTexto" }, [
                        _vm._v("Exportar"),
                        _c("br"),
                        _vm._v("CSV")
                      ])
                    ],
                    1
                  ),
                  _c(
                    "v-btn",
                    {
                      staticStyle: { "padding-right": "20px" },
                      attrs: { color: "#ffe800" },
                      on: { click: _vm.abrirmodal }
                    },
                    [
                      _c(
                        "v-icon",
                        {
                          staticStyle: { color: "black" },
                          attrs: { dark: "", left: "" }
                        },
                        [_vm._v("add_circle_outline")]
                      ),
                      _c("span", { staticStyle: { color: "black" } }, [
                        _vm._v("Crear")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _c(
            "v-flex",
            { attrs: { sm12: "", md12: "", ridcard: "", "rounded-card": "" } },
            [
              _c("MantenedorGridSinCodigo", {
                attrs: {
                  "grid-options": _vm.gridOptions,
                  "funcionalidad-id": _vm.funcionalidad
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm.modalcrear
        ? _c("VerEditarModal", {
            on: { cerrar: _vm.handleCierreModalVerDetalle }
          })
        : _vm._e(),
      _vm.mostrarModalEditar
        ? _c("EditarGrilla", {
            attrs: {
              Motivo: _vm.Motivo,
              estado: _vm.estado,
              motiid: _vm.motiid
            },
            on: { cerrar: _vm.handleCierreModal }
          })
        : _vm._e(),
      _vm.mostrarModalHistorial
        ? _c("ModalVerHistorial", {
            attrs: { motivoSelected: _vm.Motivo, motiid: _vm.motiid },
            on: { cerrar: _vm.handleCierreModal }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }